import React, { useState, useEffect } from 'react';
import './Carousel.css';

import slide1 from '../background/c1.jpg';
import slide2 from '../background/c2.jpg';
import slide3 from '../background/c3.jpg';

const Carousel = () => {
  const images = [slide1, slide2, slide3];
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [images.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  return (
    <div className="carousel">
      {/* ✅ Overlay ABOVE the image slides */}
      <div className="carousel-text-overlay">
        <h1>Japan Otaku Ex</h1>
        <p>The biggest Japanese Pop Culture Festival in the Philippines</p>
        <a href="#ticket-section">
          <button className="buy-tickets-btn">Buy Tickets</button>
        </a>
      </div>

      <div className="carousel-inner">
        {images.map((img, index) => (
          <div
            className={`carousel-item ${index === currentIndex ? 'active' : ''}`}
            key={index}
            style={{ backgroundImage: `url(${img})` }}
          ></div>
        ))}
      </div>

      <button className="carousel-btn left" onClick={prevSlide}>&#10094;</button>
      <button className="carousel-btn right" onClick={nextSlide}>&#10095;</button>

      <div className="dots">
        {images.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === currentIndex ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default Carousel;
